import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import CaseDetail from '../../components/Cases/CaseDetail';
import { Header, Spinner } from '../../components';
import { fetchAllLabs, hasAccess, http } from '../../helpers';

function CaseDetails() {
    const navigate = useNavigate();
    const { caseId } = useParams();
    const [dentalCase, setDentalCase] = useState(null);
    const [labs, setLabs] = useState([]);
    const [fetching, setFetching] = useState(true);
    const [fetchFailed, setFetchFailed] = useState(false);
    const [caseDetailGlobalState, setCaseDetailGlobalState] = useState({
        isRightPanelOpen: true,
        rightPanel: 0,
        showRenderTips: true,
    });

    useEffect(() => {
        let isCurrent = true;
        setFetching(true);
        setFetchFailed(false);

        http
            .get(`/case-api/cases/${caseId}`)
            .then(({ data }) => {
                if (isCurrent) {
                    setDentalCase(data);
                }
            })
            .catch((error) => {
                if (isCurrent) {
                    console.warn(error);
                    setFetchFailed(true);
                }
            })
            .finally(() => {
                if (isCurrent) {
                    setFetching(false);
                }
            });

        return () => {
            isCurrent = false;
        };
    }, [caseId]);

    useEffect(() => {
        if (!hasAccess('cases:write')) {
            return;
        }

        fetchAllLabs()
            .then(setLabs)
            .catch((error) => console.warn(error));
    }, []);

    const closeCase = () => {
        navigate('/cases');
    };

    const onCaseStatusChange = (id, status) => {
        setDentalCase((currentCase) => (
            currentCase?.id === id ? { ...currentCase, status } : currentCase
        ));
    };

    const onCaseLabChange = (id, labId, labName) => {
        setDentalCase((currentCase) => (
            currentCase?.id === id
                ? {
                    ...currentCase,
                    labId,
                    labName: labName === 'None' ? '' : labName,
                }
                : currentCase
        ));
    };

    if (fetching) {
        return (
            <>
                <Header label="Cases" />
                <Spinner type="page" />
            </>
        );
    }

    if (fetchFailed || !dentalCase) {
        return <Navigate to="/cases" replace />;
    }

    const patientName = (`${dentalCase.patientFirstName || ''} ${dentalCase.patientLastName || ''}`).trim();

    return (
        <CaseDetail
            {...dentalCase}
            patientName={patientName}
            numCases={1}
            index={0}
            labs={labs}
            setOpen={closeCase}
            caseDetailGlobalState={caseDetailGlobalState}
            setCaseDetailGlobalState={setCaseDetailGlobalState}
            onCaseStatusChange={onCaseStatusChange}
            onCaseLabChange={onCaseLabChange}
        />
    );
}

export default CaseDetails;
